module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAWlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////9ZMre9AAAAHXRSTlMAAwYLDRAbKCkrQkNRXF1wcXaPk7y+yNTY8vf6/OE4v38AAACzSURBVDjLrZTRDsIgDEXvkKko6oRtbJP+/2/6UB/UMNrozhMJJxBKbwEALqSZCswpODAmZlolRwMApqcqvQEQSSACLktSdggkEpB4MXmLL6yfeC+B3z61KNCyNYNljyKed1+SLUv2Q8IKv0vXoWskafcgGg+CtCciWu6NLL0fVpFo6RQS0Vkjnba5bjz+XQKrKSYuw63Z5oOrkqrphPZVBUEVKVU4VTFXDQzd6FENMcU4fAJ99VV+0il/rgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/video-36.png
// module id = km00
// module chunks = 215